import { Drawer } from 'components/Drawer'
import { DocMenuContainer } from 'components/DocMenu/DocMenuContainer'
import { ArticleView } from 'types'
import { useState } from 'react'
import { Heading } from 'blaze-ui/Heading/Heading'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { DrawerProps } from 'components/Drawer/Root'

interface Props extends DrawerProps {
  articleView?: ArticleView
  articleId: string
  hiddenKeys?: string[]
  onRename?: () => void
  onDeleteSuccess?: () => void
}

export const DocMenuDrawer = observer(
  ({ articleView, articleId, hiddenKeys, onRename, onDeleteSuccess, ...props }: Props) => {
    const { drawersStore } = useRootStore()
    const [showMove, setShowMove] = useState(false)
    const [goBack, setGoBack] = useState<() => void>()

    const handleMoveAction = (callback: (value: boolean) => void) => {
      setShowMove(true)
      setGoBack(() => callback)
    }

    const handleGoBack = () => {
      goBack?.()
      setShowMove(false)
    }

    return (
      <Drawer.Root {...props} onClose={() => setShowMove(false)}>
        <Drawer.Portal>
          <Drawer.Overlay />
          <Drawer.Content>
            <Drawer.InnerContent>
              <Drawer.Top>
                {showMove ? (
                  <Drawer.Action position="left" onPress={handleGoBack}>
                    Back
                  </Drawer.Action>
                ) : (
                  <div />
                )}
                <Drawer.Title asChild>
                  <Heading level={5}>{showMove ? 'Select Location' : 'More Options'}</Heading>
                </Drawer.Title>
                <Drawer.Close position="right" />
              </Drawer.Top>
              <Drawer.Container>
                <DocMenuContainer
                  menuType="tray"
                  id={articleId}
                  articleView={articleView}
                  hiddenKeys={new Set(hiddenKeys)}
                  dismiss={() => drawersStore.closeDrawer()}
                  onAction={(key) => {
                    if (key === 'rename') {
                      onRename?.()
                    }
                    drawersStore.closeDrawer()
                  }}
                  onMoveAction={handleMoveAction}
                  onDeleteSuccess={onDeleteSuccess}
                />
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    )
  },
)
